module.exports = __webpack_public_path__ + "static/media/whitelogo.84ebbb02.png";